import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

export const useMinPlantingDate = (plantingDate: number) => {
  const [minPlantingDate, setMinPlantingDate] = useState<Dayjs>(
    dayjs(`${plantingDate}`).add(1, "day")
  );
  useEffect(() => {
    setMinPlantingDate(dayjs(`${plantingDate}`).add(1, "day"));
  }, [plantingDate]);
  return [minPlantingDate];
};
